export default class Api {

    // Save insurance mapping override
    static submitEnrollmentForm(obj) {

        //const payload = { name: obj.name, mappedType: obj.mappedType };
        //var jsonStr = JSON.stringify(obj);
        console.log(obj);

        return fetch('/api/enrollments/create',
            {
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(obj)
            }).then(response => {
                if (response.ok && response.status === 200) {
                    return response.json();
                }
                return Promise.reject(response);
            })
            .then(data => {
                console.debug(data);
                return data;
            })
            .catch(error => {
                if (typeof error.json === "function") {
                    error.json().then(jsonError => {
                        console.warn('JSON error from API', jsonError);
                    }).catch(genericError => {
                        console.warn('Generic error from API', error.statusText);
                    });
                } else {
                    console.warn('Fetch error', error);
                }
            });
    }

    static getPlans(effectiveDate) {

        return fetch('/api/plans/getplans?effectiveDate=' + effectiveDate, { credentials: 'same-origin' })
            .then(response => {
                if (response.ok && response.status === 200) {
                    return response.json();
                }
                return Promise.reject(response);
            })
            .then(data => {
                console.debug(data);
                return data;
            })
            .catch(error => {
                if (typeof error.json === "function") {
                    error.json().then(jsonError => {
                        console.warn('JSON error from API', jsonError);
                    }).catch(genericError => {
                        console.warn('Generic error from API', error.statusText);
                    });
                } else {
                    console.warn('Fetch error', error);
                }
            });
    }

    static getPlanRates(payload, callbacks) {

        //var jsonStr = JSON.stringify(payload);
        //console.log('payload', jsonStr);

        if (typeof callbacks?.onInit === 'function') {
            callbacks.onInit();
        }

        return fetch('/api/schedules/getplanrates',
            {
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            }).then(response => {
                if (response.ok && response.status === 200) {
                    return response.json();
                }
                return Promise.reject(response);
            })
            .catch(error => {
                if (typeof error.json === 'function') {
                    error.json().then(jsonError => {
                        console.warn('JSON error from API', jsonError);
                    }).catch(genericError => {
                        console.warn('Generic error from API', error.statusText);
                    });
                } else {
                    console.warn('Fetch error', error);
                }
            })
            .then(data => {
                if (typeof callbacks?.onComplete === 'function') {
                    callbacks.onComplete();
                }

                if (data) {
                    console.debug(data);
                    return data;
                }
            })
    }
}
